import { getRedirects, removeRedirect, saveRedirect } from '@/api/redirects';
import { Redirect, RedirectsState } from '@/types/redirects';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type RedirectsGetter = GetterTree<RedirectsState, RootState>;

const state: RedirectsState = {
  redirects: [],
  editingRedirect: {
    from: '',
    to: '',
  },
};

const getters: RedirectsGetter = {
  redirects: state => state.redirects,
  editingRedirect: state => state.editingRedirect,
};

const actions: ActionTree<RedirectsState, RootState> = {
  async getRedirects({ commit }): Promise<void> {
    const redirects = await getRedirects();
    commit('setRedirects', redirects);
  },

  async removeRedirect({ commit }, id: string): Promise<void> {
    await removeRedirect(id);
    commit('removeRedirect', id);
  },

  async saveRedirect({ commit, state }) {
    const redirect = await saveRedirect(state.editingRedirect);
    commit('updateRedirect', redirect);
    commit('clearEditingRedirect');
  },
};

const mutations: MutationTree<RedirectsState> = {
  setEditingRedirect(state: RedirectsState, redirect: Redirect): void {
    state.editingRedirect = redirect;
  },

  setRedirects(state: RedirectsState, redirects: Redirect[]): void {
    state.redirects = redirects;
  },

  removeRedirect(state: RedirectsState, id: string): void {
    const index = state.redirects.findIndex(redirect => redirect.id === id);
    state.redirects.splice(index, 1);
  },

  updateRedirect(state: RedirectsState, updated: Redirect): void {
    const index = state.redirects.findIndex(
      existing => existing.id === updated.id,
    );
    if (index >= 0) {
      state.redirects.splice(index, 1, updated);
    } else {
      state.redirects.push(updated);
    }
  },

  clearEditingRedirect(state: RedirectsState): void {
    state.editingRedirect = { from: '', to: '' };
  },
};

const menus: Module<RedirectsState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default menus;
